module.exports = __webpack_public_path__ + "static/media/Tile Image  - HV 9068-1 & 5.aabea410.jpg";